import {AddToCartButton} from '@shopify/hydrogen';
import {ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import {ComponentPropsWithoutRef, useMemo} from 'react';
import {PartialDeep} from 'type-fest';
import {getVariantCartAttributes} from '../../utils/cart';

type TwlAddToCartButtonProps = ComponentPropsWithoutRef<
  typeof AddToCartButton
> & {
  variant: PartialDeep<Partial<ProductVariant>> | undefined;
};

export function TwlAddToCartButton({
  variant,
  attributes,
  children,
  ...props
}: TwlAddToCartButtonProps) {
  const attrs = useMemo(() => {
    return [...(attributes ?? []), ...getVariantCartAttributes(variant)];
  }, [attributes, variant]);
  return (
    <AddToCartButton variantId={variant?.id} attributes={attrs} {...props}>
      {children}
    </AddToCartButton>
  );
}
